import { render, staticRenderFns } from "./ApiKeys.vue?vue&type=template&id=0a52722a&scoped=true&"
import script from "./ApiKeys.vue?vue&type=script&lang=js&"
export * from "./ApiKeys.vue?vue&type=script&lang=js&"
import style0 from "./ApiKeys.vue?vue&type=style&index=0&id=0a52722a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a52722a",
  null
  
)

export default component.exports